import { render, staticRenderFns } from "./TransferHistory.vue?vue&type=template&id=797030e2"
import script from "./TransferHistory.vue?vue&type=script&lang=ts"
export * from "./TransferHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports